<template>
  <ScrollContainer>
    <EditForm
      :roles="roles"
      :entities="entities"
      :user-data="user"
      :on-cancel="handleFormCancel"
      @created="handleCreate"
      @updated="handleUpdate"
    />
  </ScrollContainer>
</template>

<script>
import ModalMixin from '@/General/Modal/ModalMixin.js'
import ScrollContainer from '@/General/Modal/ScrollContainer.vue'
import { EntityModelType } from '@/Modules/Entity/EntityModel.js'
import EditForm from '@/Modules/User/Components/EditForm.vue'
import DatasetService from '@/Modules/Dataset/DatasetService.js'
import SelectOptionModel from '@/Modules/Dataset/SelectOptionModel.js'

export default {
  name: 'CreateUserModal',

  components: {
    EditForm,
    ScrollContainer,
  },

  mixins: [ModalMixin],

  props: {
    meta: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  data() {
    return {
      roles: [],
      entities: [],
      user: this.meta.user || {},
    }
  },

  created() {
    DatasetService.byTag('roles').then((roles) => {
      this.roles = roles
    })
    DatasetService.byTag('scopedEntities').then((entities) => {
      this.entities = entities
    })
    if (_.isObject(this.user) && _.isArray(this.user.roles)) {
      this.user.roles = this.user.roles.map(
        (role) =>
          new SelectOptionModel({
            label: role.name,
            value: role.id,
          })
      )
    }

    if (
      this.authUser().entity.type === EntityModelType.AGENT &&
      this.meta.user?.defaultEntityId === undefined
    ) {
      this.user.defaultEntityId = this.authUser().entityId
    }
  },

  methods: {
    handleUpdate(user) {
      if (!user) {
        this.closeModal()
        return
      }
      this.onSuccess && this.onSuccess(user)
      this.closeModal(this.__('users.update-success'))
    },
    handleCreate(user) {
      if (!user) {
        this.closeModal()
        return
      }
      this.onSuccess && this.onSuccess(user)
      this.closeModal(this.__('users.create-success'))
    },
    handleFormCancel() {
      this.closeModal()
    },
  },
}
</script>
<style scoped>
.card-body {
  overflow: hidden;
  width: 100%;
}
</style>
